import { render, staticRenderFns } from "./NewEditAulaPagePolivalenciaInfantil.vue?vue&type=template&id=1bc120b2&scoped=true"
import script from "./NewEditAulaPagePolivalenciaInfantil.vue?vue&type=script&lang=js"
export * from "./NewEditAulaPagePolivalenciaInfantil.vue?vue&type=script&lang=js"
import style0 from "./NewEditAulaPagePolivalenciaInfantil.vue?vue&type=style&index=0&id=1bc120b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc120b2",
  null
  
)

export default component.exports